export enum BaseballAtBatCountAttribute {
  AtBatDelete = 796,
  PlateAppearanceDelete = 860,
}
